import React from 'react';

import { WebSocketEvent } from 'src/features/visitor/types';

export enum WebSocketGroup {
    GATEWAY_PASS = 'gateway_pass',
    PAY_STATION = 'pay_station',
    MONITORING_HEALTH = 'monitoring.health',
}

export type Subscriptions = {
    [key: string]: Array<(data: any) => void>;
};

export type WS = {
    subscribe: (group: WebSocketGroup, callback: (data: WebSocketEvent) => void) => void;
    unsubscribe: (group: WebSocketGroup, callback: (data: WebSocketEvent) => void) => void;
};

const WSContext = React.createContext<WS>({
    subscribe: () => {},
    unsubscribe: () => {},
});

export default WSContext;
